import { useEffect, useState } from 'react';
import { fetchFaqList } from '../../infrastructure/api/faq.api';
import type { FaqItem } from '../../application/types';

export function useFaqList(options?: { skip?: boolean }) {
  const skip = Boolean(options?.skip);
  const [items, setItems] = useState<FaqItem[]>([]);
  const [isLoading, setIsLoading] = useState(!skip);

  useEffect(() => {
    if (skip) {
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    fetchFaqList()
      .then(list => {
        if (!cancelled) {
          setItems(list);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [skip]);

  return { items, isLoading };
}
